// extracted by mini-css-extract-plugin
export default {"draggingListItem":"draggable-list-item_draggingListItem__DudzO"};